export const USE_TRANSITION = false;

/**
 * @type {Number}
 */
export const TRANSITION_DURATION = 200; // milliseconds

/**
 * Various transitions
 * @type {Object}
 */
export const TYPE = {
  initial: 'initial',
  forward: 'forward',
  backward: 'backward'
};

/**
 * Define start style for each transition type
 * @param {string} toggleMode
 * @type  {Object}
 */
const _getCommonStartStyle = toggleMode => {
  const style = {
    display: 'block',
    zIndex: 1,
    opacity: 0.4
  };
  if (toggleMode === 'visibility') {
    style.visibility = 'visible';
  }
  return style;
};
export const getStartStyle = (type, toggleMode) => {
  let style;
  switch (type) {
    case TYPE.initial:
      style = {
        left: '0px',
        top: '50px'
      };
      break;
    case TYPE.forward:
      style = {
        left: "".concat(window.innerWidth, "px"),
        top: '0px'
      };
      break;
    case TYPE.backward:
      style = {
        left: "".concat(-window.innerWidth, "px"),
        top: '0px'
      };
      break;
    default:
      console.error("Unsupported start transition type: ".concat(type));
      style = {};
  }
  return Object.assign(style, _getCommonStartStyle(toggleMode));
};

/**
 * End style, common for every transition
 * @param {string} toggleMode
 * @type  {Object}
 */
export const getEndStyle = toggleMode => {
  // Animated properties when `USE_TRANSITION` is set to true:
  const style = {
    left: '0px',
    top: '0px',
    opacity: 1
  };
  return style;
};

/**
 * Previous page style once transition has completed
 * @param {string} toggleMode
 * @type  {Object}
 */
export const getResetStyle = toggleMode => {
  const style = {
    zIndex: 0
  };
  if (toggleMode === 'visibility') {
    style.visibility = 'hidden';
  } else {
    style.display = 'none';
  }
  return style;
};